(function($, window, undefined) {
function update_quote() {};
function hideSlide() {
$('.wooslider02 .slides > li:nth-child(n+2)').css('display', 'none');

}
function update() {
update_quote();}
$(window).load(function() {
hideSlide();
$('body').addClass('open');
})
})(jQuery, window);




(function($, window, undefined) {
var $w = $(window),
$imgCovers = $('.img-cover');
function init() {
$('.img-cover').each(function() {
var $cover = $(this),
$img = $cover.find('img');
$cover.css('background-image', 'url(' + $img.attr('src') + ')');
});}






$(document).ready(function() {
$('a.arr').on('click', function(e) {
e.preventDefault();
if ($('.single-post').length) {
$('html,body').animate({ scrollTop :  $w.height() + 'px' }, '350');
} else {
$('html,body').animate({ scrollTop :  ($w.height() - 0 ) + 'px' }, '350');
}
});



$('.wooslider_wrap02 .full-H').each(function() {
$(this).css({ 'height' : $w.height() });
});

$('.wooslider_wrap02 .full-xH').each(function() {
$(this).css({ 'height' : ( $w.height()) });
});


init();

})

$(window).on('resize', function(event) {
event.preventDefault();

$('.wooslider_wrap02 .full-H').each(function() {
$(this).css({ 'height' : $w.height() });
});

$('.wooslider_wrap02 .full-xH').each(function() {
$(this).css({ 'height' : ( $w.height() ) });
});



});

})(jQuery, window);